import Cookies from 'js-cookie';
import { Preferences } from '@capacitor/preferences';

export async function setToken(token) {
  if (window.Capacitor && window.Capacitor.platform !== 'web') {
    await Preferences.set({ key: 'access_token', value: token });
  } else {
    Cookies.set('access_token', token, { expires: 3650 }); // 10 años
  }
}

export async function getToken() {
  if (window.Capacitor && window.Capacitor.platform !== 'web') {
    const { value } = await Preferences.get({ key: 'access_token' });
    return value;
  } else {
    return Cookies.get('access_token');
  }
}

export async function removeToken() {
  if (window.Capacitor && window.Capacitor.platform !== 'web') {
    await Preferences.remove({ key: 'access_token' });
  } else {
    Cookies.remove('access_token');
  }
}
